import * as React from 'react';
import { useTheme } from '@emotion/react';
import { BreakpointKeys } from 'common/theme';

export default function useBreakpoint(breakpoint: BreakpointKeys | number) {
  const [trigger, setTrigger] = React.useState(breakpoint === 0);
  const { breakpoints } = useTheme();
  const value = typeof breakpoint === 'number' ? breakpoint : breakpoints[breakpoint];
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  React.useEffect(() => {
    if (value > 0) {
      setTrigger(window.innerWidth >= value);
      const handleResize = () => {
        if (timerRef.current !== null) return;
        timerRef.current = setTimeout(() => {
          setTrigger(window.innerWidth >= value);
          timerRef.current = null;
        }, 100);
      };
      window.addEventListener('resize', handleResize, { passive: true });
      return () => {
        window.removeEventListener('resize', handleResize);
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
      };
    }
    setTrigger(true);
  }, [value]);

  return trigger;
}
